import { useCallback, useEffect, useState } from "react";
import TaskGrid from "./TaskGrid"
import { useDispatch, useSelector } from "react-redux";
import { saveTaskAssignedTo, saveTaskComment, setBulkOrderFleetHeader, setBulkOrderHeader } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import userSelectors from "redux/UserProfile/selectors";
import { getSaveAdminTaskvalue, setSaveAdminTaskvalue } from "Store/FleetManagement/FleetAdminTask/AdminTaskAction";
import ConfirmationBee from '../../../../../assets/images/ConfirmationBee.svg'
import purchaseOrderOperation from "redux/PurchaseOrder/operations";
import { selectors as purchaseOrderSelectors } from "../../../../../../redux/PurchaseOrder"
import moment from "moment";
import { CONSTANTS } from "client/utils/constants";
import { getAssetItemStatusTaskDetail } from "Store/FleetManagement/AssetItemStatusTaskDetails/AssetItemStatusTaskDetailsAction";
import { popupInitialData } from "utils";
const TaskGridContainer = (props:any) => {

    const {
        taskItemDetails,
        orderDetailId,
        taskHeaderDetails
    } = props

    const dispatch = useDispatch();

    const { bulkOrderFleetDetails, userDetails, assignTo, taskAssignedTo, taskComment, SavedAdminTaskValue, bulkOrderHeaderDetails }: any = useSelector((state: any) => ({
        bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
        userDetails: userSelectors.getUserDetails(state),
        assignTo: purchaseOrderSelectors.getAssignToDropdown(state),
        taskAssignedTo: state.PurchaseBulkOrderReducer.taskAssignedTo,
        taskComment: state.PurchaseBulkOrderReducer.taskComment,
        SavedAdminTaskValue: state.adminTaskReducer.SavedAdminTaskValue,
        bulkOrderHeaderDetails: state.PurchaseBulkOrderReducer.bulkOrderHeaderDetails
    }))

    const dispatchChangeLogs = purchaseOrderOperation.dispatchChangeLogs(dispatch);
    const [taskItemDetailsTemp, setTaskItemDetailsTemp] = useState(taskItemDetails);

    const [editComment, setEditComment] = useState<any>([]);
    const [currentEditComment, setCurrentEditComment] = useState<any>('');
    const [Popupcontent, setPopupcontent] = useState<any>({
        ...popupInitialData,
        popupOutlinebtnOnclick: () => { },
        popupPrimarybtnOnclick: () => { }
    });

    useEffect(()=>{
        setTaskItemDetailsTemp(taskItemDetails)
        const itemDetails: any = taskItemDetails ? JSON.parse(JSON.stringify(taskItemDetails)) : [];
        const tempList:any = [] 
        itemDetails.map((item:any)=>{
            item.list.map((childitem:any)=>{
                const obj = {
                    id: childitem.poFleetRequestTaskListTrackingId,
                    isShowTextBox: currentEditComment == childitem.poFleetRequestTaskListTrackingId || (!childitem?.comment?.length && !childitem?.completedOn),
                } 
                tempList.push(obj)
            })
        })
        setEditComment(tempList)
    },[taskItemDetails])

    useEffect(()=>{
        if(taskAssignedTo?.data){
            dispatchChangeLogs(taskAssignedTo?.fleetDetailId)
        }
    },[taskAssignedTo])

    useEffect(()=>{
        if(taskComment?.data){
            dispatchChangeLogs(taskComment?.fleetDetailId)
        }
    },[taskComment])
    
    const handleClickComment = (e:any,selectedItem: any) => {
        e?.preventDefault()
        if(!(taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED)){
            setCurrentEditComment(selectedItem);
            const editCommentTemp: any = editComment ? JSON.parse(JSON.stringify(editComment)) : [];
            const editedValue = editCommentTemp?.map((x: any) => {
                    if(x?.id == selectedItem){
                        x.isShowTextBox = true
                    }
                    return x;
                }
            );
            setEditComment(editedValue);
        }
    }

    const editCommentOver = (id:any) => {
        setCurrentEditComment('');
        const editCommentTemp: any = editComment ? JSON.parse(JSON.stringify(editComment)) : [];
        const editedValue = editCommentTemp?.map((x: any) => {
                if(x?.id == id ){
                    x.isShowTextBox = false
                }
                return x;
            }
        );
        setEditComment(editedValue);
    }
    
    const handleOnBlur = (itemValue:any) => {
        editCommentOver(itemValue?.poFleetRequestTaskListTrackingId)
        if(!itemValue.commentError && taskHeaderDetails.assignedTo != "Unassigned"){
            saveTheDetails(taskItemDetails)
        }
    }

    useEffect(() => {
        if (SavedAdminTaskValue?.taskList?.length > 0) {
            let SavedAdminTaskValueTemp = SavedAdminTaskValue ? JSON.parse(JSON.stringify(SavedAdminTaskValue)) : {}
          const taskListTrackings = SavedAdminTaskValueTemp?.taskList;
          let stepId = taskListTrackings?.map((item:any)=>item.stepId).filter((item:any, i:any, ar:any) => ar.indexOf(item) === i)
          let taskListTrackingsTemp:any = []
          taskListTrackingsTemp = stepId?.map((item:any)=>{
            const list = taskListTrackings.map((detailItem:any)=>
            {
              if(item == detailItem?.stepId){
                detailItem.isApplicable = !detailItem.isApplicable 
                return detailItem
              }
            }
          ).filter((childItem:any)=>childItem?.stepId == item)
            let stepTemp = taskListTrackings?.find((childItem:any)=>childItem?.stepId == item)
            return {step: stepTemp?.step,list}
          })
          const bulkOrderHeaderDetailsTemp: any = bulkOrderHeaderDetails ? JSON.parse(JSON.stringify(bulkOrderHeaderDetails)) : []
          const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
            bulkOrderFleetDetailsTemp?.map((item?: any) => {
              if (item?.orderDetailId == SavedAdminTaskValueTemp?.orderRequestId) {
                item.taskHeaderDetails?.map((childItem: any)=>{
                  if(childItem.fleetDetailId == SavedAdminTaskValueTemp.fleetItemlId){
                    childItem.taskItemDetails = taskListTrackingsTemp
                    childItem.fleetStatus = SavedAdminTaskValueTemp.fleetStatus
                    childItem.itemStatus = SavedAdminTaskValueTemp.itemStatus
                    bulkOrderHeaderDetailsTemp.orderStatus = SavedAdminTaskValueTemp.orderStatus
                  }
                })
                item.fleetRequests?.map((childItem: any)=>{
                    if(childItem.fleetItemId == SavedAdminTaskValueTemp.fleetItemlId){
                      childItem.fleetStatus = SavedAdminTaskValueTemp.fleetStatus
                      childItem.itemStatus = SavedAdminTaskValueTemp.itemStatus
                    }
                })
              }
            })
            dispatch(setBulkOrderHeader(bulkOrderHeaderDetailsTemp));
            dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
            dispatch(setSaveAdminTaskvalue({}))
            delete SavedAdminTaskValue.taskList
            dispatchChangeLogs(SavedAdminTaskValueTemp.fleetItemlId)
            dispatch(getAssetItemStatusTaskDetail({ id: SavedAdminTaskValueTemp.fleetItemlId, isRequisition: true }))
        }
    }, [SavedAdminTaskValue])
    
    const handleOnChange = (value:any, name:any, itemValue:any, step:any) => {
        let isSave = true;
        if(value == undefined) return;
        if(taskHeaderDetails?.assignedTo != undefined && taskHeaderDetails?.assignedTo != "Unassigned"){
            const itemDetails: any = taskItemDetailsTemp ? JSON.parse(JSON.stringify(taskItemDetailsTemp)) : [];
            const list = itemDetails?.map((item:any)=>{
                if(item?.step == step){
                    item?.list?.map((listItem:any)=>{   
                        if(listItem?.poFleetRequestTaskListTrackingId == itemValue?.poFleetRequestTaskListTrackingId){
                            //property update
                            listItem.isChangesOccured = true
                            listItem.completedBy = userDetails?.firstName + " " + userDetails?.lastName
                            if(name === 'completedOn'){
                                listItem.completedOn = moment(value).format("YYYY-MM-DD");
                            }else if(name === 'comment'){
                                isSave = false;
                                listItem.comment = value
                                listItem.isShowTextBox = true
                                if (value?.length > 400) {
                                    listItem.commentError = "Please enter comment less than 400 characters"
                                } else {
                                    listItem.commentError = ""
                                }
                            }else if(name === 'isApplicable') {
                                listItem.isApplicable = value;
                            }
                        }
                    })
                }
                return {step: item.step, list:item.list}
            })
            updateFleetHeader(list)
            if(isSave) saveTheDetails(list);
        }else{
            let decriptionTxt = (
                <>
                    <p>The Assigned to cannot be set to Unassigned if the item is not complete.</p>
                </>
            );

            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "OK",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false });
                }
            });
        }
    }

    const handleClearCompletedOn = (itemValue: any, step: any) => {
        let isSave = true;
        const itemDetails: any = taskItemDetailsTemp ? JSON.parse(JSON.stringify(taskItemDetailsTemp)) : [];
        const list = itemDetails.map((item: any) => {
            if (item.step == step) {
                item.list.map((listItem: any) => {
                    if (listItem?.poFleetRequestTaskListTrackingId == itemValue.poFleetRequestTaskListTrackingId && itemValue?.completedOn && !itemValue?.isApplicable) {
                        listItem.completedOn = null
                        listItem.comment = ""
                        listItem.completedBy = userDetails?.firstName + " " + userDetails?.lastName
                        listItem.isChangesOccured = true
                    }
                    else if (listItem?.poFleetRequestTaskListTrackingId == itemValue.poFleetRequestTaskListTrackingId && itemValue?.isApplicable && taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE) {
                        listItem.completedOn = null
                        listItem.completedBy = userDetails?.firstName + " " + userDetails?.lastName
                        listItem.isApplicable = false
                        listItem.comment = ""
                        listItem.isChangesOccured = true
                    }
                })
            }
            return { step: item.step, list: item.list }
        })
        if ((itemValue?.completedOn && !itemValue?.isApplicable) || (itemValue?.isApplicable && taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE)) {
            updateFleetHeader(list)
            if (isSave) saveTheDetails(list);
        }
    }

    const handleClickReset = (itemValue: any, step: any) => {
        if ((taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE && itemValue?.completedOn && itemValue?.comment != "") || (taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE && itemValue?.isApplicable)) {
            let decriptionTxt = (
                <>
                    <p>Are you sure you want to reset this task?</p>
                </>
            );

            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "CONFIRMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "No",
                primaryBtnText: "Yes",
                isSingleConfirmationBtn: false,
                popupOutlinebtnOnclick: () => {
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                },
                popupPrimarybtnOnclick: () => {
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                    handleClearCompletedOn(itemValue, step)
                }
            });
        } else {
            handleClearCompletedOn(itemValue, step)
        }
    }

    const updateFleetHeader = (list:any) => {
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == orderDetailId) {
                item.taskHeaderDetails?.map((childItem: any)=>{
                    if(childItem.fleetDetailId == taskHeaderDetails?.fleetDetailId){
                      childItem.taskItemDetails = list
                      if(!childItem.assignedTo){
                        childItem.assignedToError = "Please select assigned to"
                      }
                    }
                })
            }
        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
    }

    const saveTheDetails = (list:any) => {

        const tempList: any = []
        let listTemp = list ? JSON.parse(JSON.stringify(list)) : []
        listTemp?.map((item: any) => {
            item?.list?.map((childitem: any) => {
                if (childitem?.isChangesOccured) {
                    delete childitem.isChangesOccured
                    childitem.isApplicable = !childitem.isApplicable
                    childitem.completedOn = !childitem.isApplicable ? null :  childitem.completedOn
                    tempList.push(childitem)
                }
            })
        })
        let assetSaveValue = {
            poFleetDetailId: taskHeaderDetails?.fleetDetailId,
            savedBy: userDetails?.emailId,
            poFleetRequestTaskListTrackings: tempList,
            assignedTo: taskHeaderDetails.assignedTo,
            orderRequestId: orderDetailId,
            orderAttachments: [],
            itemAttachments: [],
            estDeliveryDate: null,
            actualDeliveryDate: null,
            newAssetNumber: 0,
            assetDetermination: true,
            assetReceivedDetail: null
        }
        dispatch(getSaveAdminTaskvalue(assetSaveValue))
    }

    const hideDialog = useCallback(
        () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
        [Popupcontent]
    );

    const onChangeAssignedTo = (selectedItem:any) => {
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == orderDetailId) {
                item.taskHeaderDetails?.map((childItem: any)=>{
                    if(childItem.fleetDetailId == taskHeaderDetails?.fleetDetailId){
                      childItem.assignedTo = selectedItem.value
                      childItem.assignedToError = ""
                    }
                })
            }
        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        const payload = {
            "fleetDetailId": taskHeaderDetails?.fleetDetailId,
            "savedBy": userDetails?.emailId,
            "assignedTo": selectedItem.value
        }
        dispatch(saveTaskAssignedTo(payload))
    }

    const onChangeComment = (e?: any) => {
        let isCommentError = false;
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == orderDetailId) {
                item.taskHeaderDetails?.map((childItem: any) => {
                    if (childItem.fleetDetailId == taskHeaderDetails?.fleetDetailId) {
                        childItem.comment = e.target.value
                        childItem.commentError = (e?.target?.value?.length > 500) ? "Please enter a comments less than 500 characters" : ""
                        if(childItem.commentError?.length > 0) isCommentError = true;
                    }
                })
            }
        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
    }

    const onBlurComment = (itemValue:any) => {
        if(!taskHeaderDetails?.commentError?.length){
            const payload = {
                "fleetDetailId": taskHeaderDetails?.fleetDetailId,
                "savedBy": userDetails?.emailId,
                "comment": itemValue.target.value
            }
            dispatch(saveTaskComment(payload))
        }
    }
    
    return(
        <TaskGrid
            taskItemDetails={taskItemDetailsTemp}
            handleClickCancel={props.handleClickCancel}
            popupOutlinebtnOnclick={props.popupOutlinebtnOnclick}
            popupPrimarybtnOnclick={props.popupPrimarybtnOnclick}
            editComment={editComment}
            handleClickComment={handleClickComment}
            handleOnChange={handleOnChange}
            handleOnBlur={handleOnBlur}
            hideDialog = {hideDialog}
            Popupcontent = {Popupcontent}
            assignTo={assignTo}
            onChangeAssignedTo={onChangeAssignedTo}
            taskHeaderDetails={taskHeaderDetails}
            onChangeComment={onChangeComment}
            onBlurComment={onBlurComment}
            handleClickReset = {handleClickReset}
        />
    )
}

export default TaskGridContainer